// extracted by mini-css-extract-plugin
export default {"isolateScroll":"isolateScroll__La4gQMlSIFuU"};